import { makeStyles, tokens } from "@fluentui/react-components";
import { AtMentionItemClassName, AtMentionMeItemClassName } from "@ms/uno-constants/lib/local/ChatConstants";
export const useChatMessageEditorStyles = makeStyles({
    root: {
        width: "100%",
        height: "100%",
        outline: "none",
        // !important is necessary to override roosterjs's inline styles
        color: "inherit !important",
        backgroundColor: "inherit !important",
        [`& span.${AtMentionItemClassName}`]: {
            color: tokens.colorBrandForeground1,
            fontWeight: tokens.fontWeightBold
        },
        [`& span.${AtMentionMeItemClassName}`]: {
            color: tokens.colorPaletteDarkOrangeForeground3,
            fontWeight: tokens.fontWeightBold
        },
        "& a": {
            color: tokens.colorBrandForegroundLink
        },
        "& blockquote": {
            margin: 0
        }
    }
});
